// extracted by mini-css-extract-plugin
module.exports = {"listSide__header":"ListSide_listSide__header__2QbxR","listSide__title":"ListSide_listSide__title__2cCfi","sticky":"ListSide_sticky__3IRyq"};